import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/auth";
import { toast } from "sonner";
import { Lock, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    if (pw.length < 8) { toast.error("Password must be 8+ characters"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-with-token", { token, new_password: pw });
      setDone(true); toast.success("Password updated");
      setTimeout(() => nav("/admin/login"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  if (!token) return <div className="min-h-screen grid place-items-center bg-[#050505] p-6">
    <div className="card-surface p-10 max-w-md w-full text-center">
      <h1 className="font-display text-3xl uppercase">Invalid link</h1>
      <p className="text-zinc-400 mt-4">This reset link is missing its token.</p>
      <Link to="/admin/login" className="btn-red mt-6 inline-flex">Go to login</Link>
    </div>
  </div>;

  return (
    <div className="min-h-screen grid place-items-center bg-[#050505] p-6">
      <form onSubmit={submit} className="card-surface p-10 w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 bg-red-600 grid place-items-center font-display">2R</div>
          <div className="font-display text-xl tracking-wider">ADMIN</div>
        </div>
        {done ? (
          <div className="text-center">
            <CheckCircle2 size={48} className="mx-auto text-emerald-500 mb-4"/>
            <h1 className="font-display text-3xl uppercase">All set</h1>
            <p className="text-zinc-400 mt-4">Redirecting to login…</p>
          </div>
        ) : (
          <>
            <h1 className="font-display text-4xl uppercase mb-6">Set your password</h1>
            <input type="password" placeholder="New password (min 8 chars)" value={pw} onChange={e => setPw(e.target.value)}
              className="w-full bg-black border border-white/10 px-4 py-3 mb-3 focus:border-red-600 outline-none" required data-testid="new-pw-input"/>
            <input type="password" placeholder="Confirm password" value={pw2} onChange={e => setPw2(e.target.value)}
              className="w-full bg-black border border-white/10 px-4 py-3 mb-4 focus:border-red-600 outline-none" required data-testid="new-pw-confirm"/>
            <button type="submit" disabled={loading} className="btn-red w-full disabled:opacity-50 flex items-center justify-center gap-2" data-testid="submit-token-reset">
              <Lock size={14}/>{loading ? "Setting…" : "Set new password"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
